module.exports = __webpack_public_path__ + "img/bl2fl01_center_003.ef018078.png";